
import Vue, { PropType } from 'vue';
import TrashCan16 from '@carbon/icons-vue/es/trash-can/16';
import Edit16 from '@carbon/icons-vue/es/edit/16';
import { ProductPrintPositionAddModel } from '@/typings';
import { mapActions, mapState } from 'pinia';
import { useStore as useProductStore } from '../../../../stores/v2/product';
import { useStore as useLangStore } from '../../../../stores/v2/lang';
import { UnavailableProductPrintPosition } from '../../typings/product';

export default Vue.extend({
  name: 'PrintPositionBox',
  components: {
    TrashCan16,
    Edit16,
  },
  props: {
    isDeleteDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    position: {
      type: Object as PropType<UnavailableProductPrintPosition>,
      default: null,
    },
    isSelectedPrintPosition: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useProductStore, [
      'selectedVariant',
      'printPositions',
      'isFullColor',
      'getTechniqueMaxColors',
    ]),
    ...mapState(useLangStore, ['languageInUse']),

    maximumColoursRepresentation(): string {
      const isFullColor = this.isFullColor(this.position.positionId);

      if (isFullColor) {
        return this.$t('print-position.full-colour').toString();
      }

      const maxColors = this.getTechniqueMaxColors(
        this.position.positionId,
        this.position.technique.id
      );

      return maxColors === 1
        ? this.$tc('print-position.number-colours')
        : this.$tc('print-position.number-colours', maxColors, {
            number: maxColors,
          });
    },

    techniqueNameTranslated(): string {
      const position = this.printPositions.find(
        (p) => p.id === this.position.positionId
      );
      const technique = position?.printTechniques.find((technique) => {
        return technique.id === this.position.technique.id;
      });
      const techniqueName = technique?.printTechnique.nameTranslations.find(
        ({ language }) => language.code === this.languageInUse
      )?.text;
      return techniqueName || '';
    },

    selectedVariantImageUrl(): string | undefined {
      if (this.position && this.selectedVariant) {
        const variantImage = this.selectedVariant.images?.find(
          (img) => img.printPositionID === this.position.positionId
        );
        return variantImage ? variantImage.imageThumbnailUrl : undefined;
      }
      return undefined;
    },
  },
  methods: {
    ...mapActions(useProductStore, ['setSelectedPrintPosition']),

    selectPrintPosition(position: ProductPrintPositionAddModel) {
      this.setSelectedPrintPosition(position.positionId);
    },
  },
});
